var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1796 0.573364C11.7211 0.573364 0 12.2947 0 26.753C0 41.2124 11.7213 52.9327 26.1796 52.9327C40.6392 52.9327 52.3593 41.2124 52.3593 26.753C52.3593 12.2957 40.6392 0.574796 26.1792 0.574796L26.1796 0.573364ZM38.1853 38.3322C37.7163 39.1012 36.7096 39.345 35.9406 38.873C29.7939 35.1184 22.0562 34.268 12.9434 36.3501C12.5214 36.4461 12.0785 36.3707 11.7122 36.1403C11.3458 35.9099 11.086 35.5434 10.9897 35.1215C10.9418 34.9126 10.9355 34.6963 10.9712 34.485C11.007 34.2737 11.084 34.0715 11.198 33.89C11.312 33.7085 11.4607 33.5513 11.6355 33.4273C11.8103 33.3034 12.0079 33.2151 12.2169 33.1676C22.1897 30.8892 30.7437 31.8701 37.6445 36.0875C38.4135 36.5595 38.6573 37.5632 38.1853 38.3322ZM41.3896 31.2038C40.7985 32.164 39.5419 32.4673 38.5823 31.8765C31.5452 27.5511 20.8183 26.2983 12.4951 28.8249C11.4156 29.1509 10.2755 28.5426 9.94786 27.465C9.62266 26.3855 10.2313 25.2475 11.309 24.9194C20.8165 22.0343 32.6362 23.4319 40.7175 28.3978C41.6772 28.9889 41.9805 30.2453 41.3896 31.2038ZM41.6647 23.7808C33.2271 18.769 19.3063 18.308 11.2505 20.7534C9.95686 21.1457 8.58877 20.4153 8.19689 19.1216C7.80481 17.8274 8.53436 16.4603 9.82903 16.067C19.0764 13.2597 34.4496 13.8023 44.1636 19.5692C45.3299 20.2596 45.7111 21.7625 45.0202 22.9244C44.3326 24.0882 42.8256 24.4717 41.6659 23.7808H41.6647Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.3593,
    height: 52.3593,
    fill: "white",
    transform: "translate(0 0.573364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.6a57f7b26de6c905fbacf927dea73e7c.svg";
export { ForwardRef as ReactComponent };